module.exports = __webpack_public_path__ + "static/media/betala.9e46ef6a.mp3";